'use strict';

var _regeneratorRuntime = require("/codebuild/output/src122629992/src/niftron-profile/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator");

var _asyncToGenerator = require("/codebuild/output/src122629992/src/niftron-profile/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/asyncToGenerator");

var _asyncIterator = require("/codebuild/output/src122629992/src/niftron-profile/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/asyncIterator");

var abortable = require('abortable-iterator');

var AbortController = require('abort-controller');

var log = require('debug')('libp2p:mplex:stream');

var pushable = require('it-pushable');

var BufferList = require('bl/BufferList');

var _require = require('./restrict-size'),
    MAX_MSG_SIZE = _require.MAX_MSG_SIZE;

var _require2 = require('./message-types'),
    InitiatorMessageTypes = _require2.InitiatorMessageTypes,
    ReceiverMessageTypes = _require2.ReceiverMessageTypes;
/**
 * @param {object} options
 * @param {number} options.id
 * @param {string} options.name
 * @param {function(*)} options.send Called to send data through the stream
 * @param {function(Error)} [options.onEnd] Called whenever the stream ends
 * @param {string} [options.type] One of ['initiator','receiver']. Defaults to 'initiator'
 * @param {number} [options.maxMsgSize] Max size of an mplex message in bytes. Writes > size are automatically split. Defaults to 1MB
 * @returns {*} A muxed stream
 */


module.exports = function (_ref) {
  var id = _ref.id,
      name = _ref.name,
      send = _ref.send,
      _ref$onEnd = _ref.onEnd,
      onEnd = _ref$onEnd === void 0 ? function () {} : _ref$onEnd,
      _ref$type = _ref.type,
      type = _ref$type === void 0 ? 'initiator' : _ref$type,
      _ref$maxMsgSize = _ref.maxMsgSize,
      maxMsgSize = _ref$maxMsgSize === void 0 ? MAX_MSG_SIZE : _ref$maxMsgSize;
  var abortController = new AbortController();
  var resetController = new AbortController();
  var Types = type === 'initiator' ? InitiatorMessageTypes : ReceiverMessageTypes;
  var externalId = type === 'initiator' ? "i".concat(id) : "r".concat(id);
  name = String(name == null ? id : name);
  var sourceEnded = false;
  var sinkEnded = false;
  var endErr;

  var onSourceEnd = function onSourceEnd(err) {
    sourceEnded = true;
    log('%s stream %s source end', type, name, err);
    if (err && !endErr) endErr = err;

    if (sinkEnded) {
      stream.timeline.close = Date.now();
      onEnd(endErr);
    }
  };

  var onSinkEnd = function onSinkEnd(err) {
    sinkEnded = true;
    log('%s stream %s sink end', type, name, err);
    if (err && !endErr) endErr = err;

    if (sourceEnded) {
      stream.timeline.close = Date.now();
      onEnd(endErr);
    }
  };

  var stream = {
    // Close for reading
    close: function close() {
      return stream.source.end();
    },
    // Close for reading and writing (local error)
    abort: function abort(err) {
      log('%s stream %s abort', type, name, err); // End the source with the passed error

      stream.source.end(err);
      abortController.abort();
    },
    // Close immediately for reading and writing (remote error)
    reset: function reset() {
      return resetController.abort();
    },
    sink: function () {
      var _sink = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(source) {
        var _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, _value, data;

        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                source = abortable(source, [{
                  signal: abortController.signal,
                  options: {
                    abortMessage: 'stream aborted',
                    abortCode: 'ERR_MPLEX_STREAM_ABORT'
                  }
                }, {
                  signal: resetController.signal,
                  options: {
                    abortMessage: 'stream reset',
                    abortCode: 'ERR_MPLEX_STREAM_RESET'
                  }
                }]);

                if (type === 'initiator') {
                  // If initiator, open a new stream
                  send({
                    id: id,
                    type: Types.NEW_STREAM,
                    data: name
                  });
                }

                _context.prev = 2;
                _iteratorNormalCompletion = true;
                _didIteratorError = false;
                _context.prev = 5;
                _iterator = _asyncIterator(source);

              case 7:
                _context.next = 9;
                return _iterator.next();

              case 9:
                _step = _context.sent;
                _iteratorNormalCompletion = _step.done;
                _context.next = 13;
                return _step.value;

              case 13:
                _value = _context.sent;

                if (_iteratorNormalCompletion) {
                  _context.next = 28;
                  break;
                }

                data = _value;

              case 16:
                if (!data.length) {
                  _context.next = 25;
                  break;
                }

                if (!(data.length <= maxMsgSize)) {
                  _context.next = 20;
                  break;
                }

                send({
                  id: id,
                  type: Types.MESSAGE,
                  data: data
                });
                return _context.abrupt("break", 25);

              case 20:
                data = BufferList.isBufferList(data) ? data : new BufferList(data);
                send({
                  id: id,
                  type: Types.MESSAGE,
                  data: data.shallowSlice(0, maxMsgSize)
                });
                data.consume(maxMsgSize);
                _context.next = 16;
                break;

              case 25:
                _iteratorNormalCompletion = true;
                _context.next = 7;
                break;

              case 28:
                _context.next = 34;
                break;

              case 30:
                _context.prev = 30;
                _context.t0 = _context["catch"](5);
                _didIteratorError = true;
                _iteratorError = _context.t0;

              case 34:
                _context.prev = 34;
                _context.prev = 35;

                if (!(!_iteratorNormalCompletion && _iterator.return != null)) {
                  _context.next = 39;
                  break;
                }

                _context.next = 39;
                return _iterator.return();

              case 39:
                _context.prev = 39;

                if (!_didIteratorError) {
                  _context.next = 42;
                  break;
                }

                throw _iteratorError;

              case 42:
                return _context.finish(39);

              case 43:
                return _context.finish(34);

              case 44:
                _context.next = 51;
                break;

              case 46:
                _context.prev = 46;
                _context.t1 = _context["catch"](2);

                // Send no more data if this stream was remotely reset
                if (_context.t1.code === 'ERR_MPLEX_STREAM_RESET') {
                  log('%s stream %s reset', type, name);
                } else {
                  log('%s stream %s error', type, name, _context.t1);
                  send({
                    id: id,
                    type: Types.RESET
                  });
                }

                stream.source.end(_context.t1);
                return _context.abrupt("return", onSinkEnd(_context.t1));

              case 51:
                send({
                  id: id,
                  type: Types.CLOSE
                });
                onSinkEnd();

              case 53:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, null, [[2, 46], [5, 30, 34, 44], [35,, 39, 43]]);
      }));

      function sink(_x) {
        return _sink.apply(this, arguments);
      }

      return sink;
    }(),
    source: pushable(onSourceEnd),
    timeline: {
      open: Date.now(),
      close: null
    },
    id: externalId
  };
  return stream;
};